import { formatEuro } from '../utils/calculs'
import { formatCourt } from '../utils/planning'
import '../pages/superviseur/MonEspace.css'

// Affichage en 3 colonnes, une par facture : supervision (spa + hydro + reunion),
// accueil, assistanat de cours. Partage entre "Mes seances" (superviseur)
// et "Recapitulatif > Par superviseur" (coordination).

function Colonne({ titre, sousTitre, total, children, vide }) {
  return (
    <section className="me-col">
      <header className="me-col-head">
        <div>
          <div className="me-col-titre">{titre}</div>
          {sousTitre && <div className="me-col-sous">{sousTitre}</div>}
        </div>
        <div className="me-col-total">{formatEuro(total)}</div>
      </header>
      <div className="me-col-body">
        {vide ? <div className="me-col-vide">Rien ce mois-ci</div> : children}
      </div>
    </section>
  )
}

function Ligne({ l }) {
  return (
    <div className="me-ligne">
      <span className="me-ligne-date">{formatCourt(l.date)}</span>
      {l.libelle && <span className={`me-tag me-tag-${l.type}`}>{l.libelle}</span>}
      <span className="me-ligne-details">
        {l.details}
        {l.cloture && <span className="me-badge-cloture">Clôturé</span>}
      </span>
      <span className="me-ligne-montant">{formatEuro(l.montant)}</span>
    </div>
  )
}

// remunSeance(s) : remuneration du superviseur concerne pour une seance (gere le partage horaire)
export default function ColonnesFactures({ seances, accueil, reunions, assistanat, remunSeance }) {
  const totaux = {
    remuneration: seances.reduce((a, s) => a + remunSeance(s), 0),
    accueil: accueil.reduce((a, s) => a + (s.montant || 0), 0),
    reunions: reunions.reduce((a, r) => a + (r.montant || 0), 0),
    assistanat: assistanat.reduce((a, r) => a + (r.montant || 0), 0),
    payants: seances.reduce((a, s) => a + (s.total_massage_payant || 0), 0),
  }
  const totalSupervision = totaux.remuneration + totaux.reunions

  const lignesSupervision = seances.map(x => {
    const hydro = x.pole === 'HYDRO'
    return { cle: `s${x.id}`, date: x.date, type: hydro ? 'hydro' : 'spa', libelle: hydro ? 'Hydro' : 'Spa', details: `${x.total_massage_payant || 0} + ${x.total_massage_gratuit || 0}`, montant: remunSeance(x), cloture: x.cloture }
  })
  const lignesAccueil = accueil.map(x => ({ cle: `a${x.id}`, date: x.date, type: 'accueil', libelle: '', details: '', montant: x.montant || 0, cloture: x.cloture }))
  const lignesAssistanat = assistanat.map(x => ({ cle: `c${x.id}`, date: x.date, type: 'assistanat', libelle: '', details: x.cours || '', montant: x.montant || 0, cloture: false }))
  const lignesReunions = reunions.map(x => ({ cle: `r${x.id}`, date: x.date, type: 'reunion', libelle: '', details: `${x.duree_heures} h`, montant: x.montant || 0, cloture: false }))

  return (
    <div className="me-cols">
      <Colonne
        titre="Supervision"
        sousTitre={`${seances.length} séance${seances.length > 1 ? 's' : ''} · ${totaux.payants} soins payants · lignes : payants + gratuits`}
        total={totalSupervision}
        vide={lignesSupervision.length === 0 && lignesReunions.length === 0}
      >
        {lignesSupervision.map(l => <Ligne key={l.cle} l={l} />)}
        {lignesReunions.length > 0 && (
          <div className="me-encart">
            <div className="me-encart-titre">Réunion du mois</div>
            {lignesReunions.map(l => <Ligne key={l.cle} l={l} />)}
          </div>
        )}
      </Colonne>

      <Colonne
        titre="Accueil"
        sousTitre={`${accueil.length} journée${accueil.length > 1 ? 's' : ''}`}
        total={totaux.accueil}
        vide={lignesAccueil.length === 0}
      >
        {lignesAccueil.map(l => <Ligne key={l.cle} l={l} />)}
      </Colonne>

      <Colonne
        titre="Assistanat de cours"
        sousTitre={`${assistanat.length} journée${assistanat.length > 1 ? 's' : ''}`}
        total={totaux.assistanat}
        vide={lignesAssistanat.length === 0}
      >
        {lignesAssistanat.map(l => <Ligne key={l.cle} l={l} />)}
      </Colonne>
    </div>
  )
}
